export enum errorAuth {
	'EMAIL_NONE' = 'Please input your email!',
	'EMAIL_FORMAT' = 'Email not correct format!',
	'PASSWORD_NONE' = 'Please input your password!',
	'PASSWORD_LENGTH' = 'Password over 6 chacracters',
}
